export const skills = [
    {
        name: 'React.js',
        score: 80,
        icon: 'React'
    },
    {
        name: 'Javascript',
        score: 90,
        icon: 'Js'
    },
    {
        name: 'Golang',
        score: 80,
        icon: 'Go'
    },
    {
        name: 'Python',
        score: 80,
        icon: 'Python'
    },
    {
        name: 'RoR',
        score: 80,
        icon: 'Ror'
    },
    {
        name: 'Node.js',
        score: 80,
        icon: 'NodeJs'
    },
    {
        name: 'Ember.js',
        score: 90,
        icon: 'Ember'
    },
    {
        name: 'HTML5',
        score: 95,
        icon: 'Html5'
    },
    {
        name: 'CSS',
        score: 80,
        icon: 'Css3'
    },
    {
        name: 'Java',
        score: 90,
        icon: 'Java'
    },
    {
        name: 'Docker',
        score: 80,
        icon: 'Docker'
    },
    {
        name: 'SQL',
        score: 80,
        icon: 'Database'
    },
    {
        name: 'MongoDB',
        score: 70,
        icon: 'Mongodb'
    },
    {
        name: 'kubernetes',
        score: 70,
        icon: 'Kubernetes'
    }
]